import storage from 'redux-persist/lib/storage/session'; // defaults to localStorage for web and AsyncStorage for react-native
import merge from 'deepmerge';

import constants from '@/utils/constants';

import {
	saveRefundsFilters,
	saveTransactionFilters,
	saveDashboardFilters,
	saveSettlementFilters,
	saveManageQRFilters,
	saveRefundsFiltersBlackList,
	saveStoreListFilters,
	saveManageQRFiltersBlackList,
	saveUserProfileInfo,
	saveFilteredUserConfig,
} from './persistTransformFilters';

const overwriteMerge = (destinationArray, sourceArray) => sourceArray;

const rootPersistConfig = {
	key: 'root',
	storage,
	whitelist: [
		'refunds',
		'transactions',
		'dashboard',
		'settlement',
		'manageQR',
		'store',
		'userProfile',
		'userConfig',
		'kyc',
	], // https://github.com/rt2zz/redux-persist/issues/277  : This tells why we have to use transform to whitelist nested state properties
	version: constants.BUILD_NUMBER, // NOTE: Test for conflicts of storage on two consecutive builds

	debug: constants.BUILD_ENVIRONMENT === 'development',
	transforms: [
		saveRefundsFilters,
		saveRefundsFiltersBlackList,
		saveFilteredUserConfig,
		saveTransactionFilters,
		saveDashboardFilters,
		saveSettlementFilters,
		saveManageQRFilters,
		saveStoreListFilters,
		saveManageQRFiltersBlackList,
		saveUserProfileInfo,
	],
	stateReconciler: (inboundState, reducedState) => {
		const mergeConfig = { arrayMerge: overwriteMerge };
		// function to deepmerge
		const newState = merge(reducedState, inboundState, mergeConfig);
		return newState;
	},
};

export default rootPersistConfig;
